import { useState } from "react";
import ShowMyOrder from "./showMyOrder";
import { Button } from "@mui/material";
import { ControlPointDuplicate, DeliveryDining, ExpandMore, LocalMallOutlined } from "@mui/icons-material";
import MyDateTime from "../../../DTechComp/MyDateTime";
import "../MyProfile.css";


const MyClosedOrderDisp = (props) => {

    const [theOrder] = useState(props.theOrder);
    const [shown, setShown] = useState(false);

    const isDeliver = theOrder.ord.OrderType !== "Take";

    return (
        <div className={"ordAccordionItem"}>

            <div className={"ordAccordionHeader"} onClick={() => setShown(!shown)}>
                <div className={`ordAccordionIcon${isDeliver ? " ordAccordionIcon--deliver" : ""}`}>
                    {isDeliver
                        ? <DeliveryDining sx={{ color: '#41bd31', fontSize: 18 }} />
                        : <LocalMallOutlined sx={{ color: 'var(--btnBlue)', fontSize: 18 }} />
                    }
                </div>
                <div className={"fullRow"}>
                    <span className={"mediumst"}>{MyDateTime.getDate(theOrder.ord.dateCreated)}</span>
                    <br />
                        <p className={"MbigFont"}>{theOrder.buiss.buissName}</p>
                </div>
                <div className={"fullRow"}>

                    {isDeliver ? "משלוח" : "איסוף"}
                    {", "}
                    {theOrder.ord.orderStatus}
                </div>
                <ExpandMore className={`ordAccordionChevron${shown ? " ordAccordionChevron--open" : ""}`} />
            </div>

            <div className={`ordAccordionBody${shown ? " ordAccordionBody--open" : ""}`}>
                <div className={"col-12"}>
                    <div className={"row"}>

                        <div className={"col-12 overflowHid"}>
                            <div className={"onLeft pointing onTopOfSome"}>
                                <Button className={"myBtnWithIcon"} variant="outlined"
                                    startIcon={<ControlPointDuplicate />}
                                    onClick={() => props.duplicThisOrder(theOrder.ord._id)}
                                >
                                    <span className={"btnWithIconTxt"}>שכפל הזמנה</span>
                                </Button>
                            </div>
                        </div>

                        <div className={"col-12 pointing"}>
                            <div className={"MbigFont bold SecondFont onRight"}>{theOrder.buiss.buissName}</div>
                        </div>

                        <div className={"col-12"}>
                            <div className={"openOrdBx orderLINE"}>
                                <div className={"small"}>מספר הזמנה: {theOrder.ord.orderNUM}</div>
                            </div>
                        </div>

                        <div className={"countTxtOrder"}>
                            <div className={"big"}>סטטוס: {theOrder.ord.orderStatus}</div>
                        </div>

                        <ShowMyOrder theOrder={theOrder.ord} />

                    </div>
                </div>
            </div>

        </div>
    );
};

export default MyClosedOrderDisp;
